import { Profiles } from '@core/constants/profiles';
import { CheckinBody } from './store.api';

export interface CampaignId {
  campaign_id: number;
}

export interface User {
  id: string;
  name: string;
  role: Profiles;
  validateCheckIn?: boolean;
  activeCheckin?: {
    id: number;
    campaign: number;
    latitude: number,
    longitude: number,
  };
  campaigns?: CampaignId[];
  lastLogin: Date;
}

export interface AuthData {
  user?: User;
  accessToken?: string;
  loading?: boolean;
}

export interface AuthActions {
  login: (params: { document: string; password: string }) => Promise<User>;
  setUser: (user: User) => void;
  setAccessToken: (token: string) => void;
  checkin: (
    campaignId: number | string,
    checkinData: CheckinBody
  ) => Promise<void>;
  checkout: () => Promise<void>;
  reset: () => void;
}

export type AuthStore = AuthData & AuthActions;

export const initialAuthState: AuthData = {
  user: undefined,
  accessToken: undefined,
};
